/* ReBrandMD — analytics & ad pixels (PLACEHOLDER IDs — replace before launch).
   Pixels stay inert until real IDs are added, so there are no errors/network calls in the demo.
   Replace the three IDs below, then verify events in Meta Events Manager / TikTok Events / GA4 DebugView.
   NOTE: client-side only. Server-side Conversions API (Meta/TikTok) requires a backend endpoint. */
window.REBRAND_IDS = {
  meta:   'META_PIXEL_ID',      // Meta (Facebook/Instagram) Pixel ID
  tiktok: 'TIKTOK_PIXEL_ID',    // TikTok Pixel ID
  ga4:    'GA4_MEASUREMENT_ID'  // Google Analytics 4 Measurement ID (G-XXXXXXX)
};
(function(){
  var ID = window.REBRAND_IDS;

  // ---- Meta Pixel ----
  if(ID.meta && ID.meta !== 'META_PIXEL_ID'){
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ID.meta); fbq('track','PageView');
  }

  // ---- TikTok Pixel ----
  if(ID.tiktok && ID.tiktok !== 'TIKTOK_PIXEL_ID'){
    !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var s="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=s;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=d.createElement("script");o.type="text/javascript";o.async=!0;o.src=s+"?sdkid="+e+"&lib="+t;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load(ID.tiktok);ttq.page();}(window,document,'ttq');
  }

  // ---- Google Analytics 4 ----
  if(ID.ga4 && ID.ga4 !== 'GA4_MEASUREMENT_ID'){
    var g=document.createElement('script'); g.async=1; g.src='https://www.googletagmanager.com/gtag/js?id='+ID.ga4; document.head.appendChild(g);
    window.dataLayer=window.dataLayer||[]; window.gtag=function(){dataLayer.push(arguments);}; gtag('js',new Date()); gtag('config',ID.ga4);
  }

  // ---- Unified event tracker (call from anywhere: window.track('Lead', {...})) ----
  window.track = function(name, params){
    params = params || {};
    try{ if(window.fbq) fbq('track', name, params); }catch(e){}
    try{ if(window.ttq) ttq.track(name, params); }catch(e){}
    try{ if(window.gtag) gtag('event', name, params); }catch(e){}
    if(!window.fbq && !window.ttq && !window.gtag && window.console){ console.debug('[track:placeholder]', name, params); }
  };
})();
